import { useAuthStore } from './authStore';

/**
 * Кто вошёл в приложение.
 *
 * Бэкенд отдаёт почту и идентификатор, но не имя, поэтому подписью аккаунта
 * служит почта. Придумывать отображаемое имя нельзя: пользователь принял бы
 * его за настоящее.
 */
export interface AccountIdentity {
  title: string;
  email: string | null;
  initials: string;
}

function initialsOf(source: string): string {
  // У почты берётся часть до @: домен к человеку отношения не имеет
  const local = source.split('@')[0] ?? source;
  const parts = local.split(/[\s._-]+/).filter(Boolean);
  if (parts.length === 0) return '—';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return parts
    .slice(0, 2)
    .map((word) => word[0])
    .join('')
    .toUpperCase();
}

export function useAccountIdentity(): AccountIdentity {
  const user = useAuthStore((state) => state.user);
  const email = typeof user?.email === 'string' ? user.email : null;

  return {
    title: email ?? 'Ваш аккаунт',
    email,
    initials: initialsOf(email ?? 'Аккаунт'),
  };
}
